/*
 * @Author: taowuhua
 * @:
 * @Date: 2024-11-18 09:50:41
 * @LastEditors: taowuhua
 * @LastEditTime: 2024-11-18 10:56:52
 * @Description: file content
 */
import Vue from "vue"
import "vant/lib/index.css"
import "swiper/dist/css/swiper.css"
import VueAwesomeSwiper from "vue-awesome-swiper"
import App from "./App.vue"
import router from "./router"
import Vant from "vant"
import http from "./utils/api" // 引入配置好拦截器的axios实例
import store from "@/store" //状态管理
import { Dialog } from 'vant';


// 将axios实例挂载到Vue原型上，实现全局引用
Vue.prototype.$http = http
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueAwesomeSwiper)
Vue.use(Dialog);

new Vue({
  router, // 注册路由插件
  store,
  render: (h) => h(App),
}).$mount("#app")
